import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '../icon';
import Render from '../render';
import Text from '../text';
import withUnit from '../utils/with-unit';

class Brand extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hovered: false,
    };

    this.bindMethods();
  }

  onMouseEnter() {
    this.setState({
      hovered: true,
    });
  }

  onMouseLeave() {
    this.setState({
      hovered: false,
    });
  }

  bindMethods() {
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.onMouseEnter = this.onMouseEnter.bind(this);
  }

  render() {
    const { className, style, logo, alt, defaultWidth, altWidth, onClick, alignLogo } = this.props;
    const { hovered } = this.state;
    const hasAltText = Boolean(onClick);
    const minWidth = hovered && hasAltText ? altWidth : defaultWidth;
    const brandStyle = {
      ...style,
      width: withUnit(defaultWidth),
      minWidth: alignLogo !== 'center' ? withUnit(defaultWidth) : withUnit(minWidth),
    };

    const brandClass = classNames('ws-brand', {
      'ws-brand--disabled-alt': !hasAltText,
      'ws-brand--hovered': hasAltText && hovered,
      [`ws-brand--${alignLogo}-aligned`]: alignLogo !== 'center',
    });

    const brandLogoClass = classNames(className, 'ws-brand__logo');
    const wrapperStyle = {
      width: withUnit(defaultWidth),
      minWidth: withUnit(minWidth),
    };

    return (
      <div
        className={brandClass}
        onMouseEnter={hasAltText ? this.onMouseEnter : null}
        onMouseLeave={hasAltText ? this.onMouseLeave : null}
        style={wrapperStyle}
      >
        <div className={brandLogoClass} style={brandStyle}>
          <img
            className="ws-brand__logo-img"
            src={logo.src}
            width={logo.width}
            height={logo.height}
            alt={alt}
          />
        </div>

        <Render if={hasAltText}>
          <div
            className="ws-brand__alt-text"
            style={{ width: withUnit(altWidth) }}
            onClick={onClick}
          >
            <Icon glyph="chevron-left" />
            <Text>{alt}</Text>
          </div>
        </Render>
      </div>
    );
  }
}

Brand.propTypes = {
  className: PropTypes.string,
  style: PropTypes.shape(),
  logo: PropTypes.shape({
    src: PropTypes.string.isRequired,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  }).isRequired,
  alt: PropTypes.string,
  defaultWidth: PropTypes.number.isRequired,
  altWidth: PropTypes.number.isRequired,
  onClick: PropTypes.func,
  alignLogo: PropTypes.oneOf(['left', 'center', 'right']),
};

Brand.defaultProps = {
  className: null,
  style: {},
  alt: '',
  onClick: null,
  alignLogo: 'center',
};

export default Brand;
